import { Grid , Button } from '@mui/material';
import React, { useMemo } from 'react';
import { useSearchParams , useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ViewAttachmentsTable from '../AppGrid/ViewAttachmentsTable';
import { useBreadcrumbs } from '../contexts/Breadcrumbs';
import { useUniqueEffect } from '../hooks';
import Connection from '../services/Connection';
import strings from '../Globalization';

const EquipmentAttachment=()=>{
	const navigate = useNavigate();
	const [breadcrumbs, setBreadcrumbs] = useBreadcrumbs();
	const [searchParams]= useSearchParams();
	const equipmentId = searchParams.get('equipmentId') || '';
	const BackButton = () => {
		return (<Button variant='contained' startIcon={<ArrowBackIcon />} onClick={() => { navigate(-1) }}>{strings.Back}</Button>)
	}
	const getEquipmentData = async () => {
		const formData = new FormData();
		formData.append('equipmentId', equipmentId);
		formData.append('otherAction', 'getEquipmentData');
		formData.append('action', 'otherAction');
		const response = await fetch(Connection.ViewAttachment, {
			method: 'POST',
			body: formData
		});
		const data = await response.json();
		if (data.success) {
			setBreadcrumbs({ docTitle: 'Equipment Attachment', breadcrumbs: [{ text: `${data.data.DeviceType}-${data.data.SerialNumber}` }], actions: [{ component: BackButton }] });
		}
	}
	useUniqueEffect(() => {
		(async () => {
			await getEquipmentData();
		})()
	}, []);

	const parentFilters = useMemo(() => {
		return {
			filter: [{ "operator": "$eq", "value": equipmentId, "property": "EquipmentId" }]
	}}, [equipmentId]);

	return (
		<Grid container>
			<Grid size={12}>
				<ViewAttachmentsTable parentFilters={parentFilters} />
			</Grid>
		</Grid>
	);
}

export default EquipmentAttachment;